import { render } from "./ProducibilityView.vue?vue&type=template&id=be5b3daa&scoped=true"
import script from "./ProducibilityView.vue?vue&type=script&lang=js"
export * from "./ProducibilityView.vue?vue&type=script&lang=js"

import "./ProducibilityView.vue?vue&type=style&index=0&id=be5b3daa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be5b3daa"]])

export default __exports__